module.exports = __webpack_public_path__ + "static/img/primary_placeholder.1bcca87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholder/primary_placeholder.png
// module id = 19Y9
// module chunks = 7